export default __webpack_public_path__ + "static/media/settings.b6e1617a.svg";